import React, {Component} from 'react';
import styles from "../DatiSpecifici.module.css";
import Button from "../../../../../components/button/Button";
import Icon from "../../../../../components/icon/Icon";
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../../utils/OggettiUtili";
import Utils from "../../../../../utils/Utils";
import MalattieService from "../../../../../services/MalattieService";
import Select from "../../../../../components/select/Select"
import $ from "jquery";
import SelectAutocomplete from "../../../../../components/selectAutocomplete/SelectAutocomplete";
import SessioneUtente from "../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../utils/Ruoli";

class Contatti extends Component {

    state = {
        contatto: {
            listaContatti: [{
                contatto: this.props.malattiePremal.includes(this.props.malattia)? "159*" : "",
                grado: ""
            }],
            corretto: ["Campo \"Contatto\" mancante"]
        },
        clicks: 0,
        boxesContatti: [],
        listaGrado: OggettiUtili.Grado,
        listaContattiSelect: []
    }

    constructor(props) {
        super(props);
        this.handleChangeContatto = this.handleChangeContatto.bind(this)
        this.handleChangeGradoRelazioneContatto = this.handleChangeGradoRelazioneContatto.bind(this)
        this.onClickAggiungiContatti = this.onClickAggiungiContatti.bind(this)
        this.aggiungiContatto = this.aggiungiContatto.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
        this.createJsonForBackend = this.createJsonForBackend.bind(this)
        this.validate = this.validate.bind(this)
        this.uniqueObjectContatti = this.uniqueObjectContatti.bind(this)
        this.eliminaRow = this.eliminaRow.bind(this)
    }

    componentDidMount() {

        this.controlloCorrettezza()

        MalattieService.getContatti(this.props.malattia).then((data) => {
            let listaContattiSelect = Utils.mapToArray(data.data);
            this.setState({listaContattiSelect: listaContattiSelect})
            $(function () {
                $('.selectpicker').selectpicker('refresh');
            });
            this.onClickAggiungiContatti();
        }).catch(() => {
            console.log("errore chiamata contatti")
        });

        if (this.props.segnalazioneDatiSpecificiCopia.datiSpecifici && this.props.segnalazioneDatiSpecificiCopia.datiSpecifici.contatto) {
            let contatto = this.state.contatto
            let propsContatti = JSON.parse(JSON.stringify(this.props.segnalazioneDatiSpecificiCopia.datiSpecifici.contatto));
            if (propsContatti.listaContatti && propsContatti.listaContatti.length > 0) {
                contatto.listaContatti = propsContatti.listaContatti
                for (let i = 0; i < contatto.listaContatti.length; i++) {
                    this.onClickAggiungiContatti();
                    this.setState({contatto: contatto, clicks: i})
                }
            } else {
                contatto.listaContatti = this.state.contatto.listaContatti
            }
            this.setState({contatto: contatto})
            this.controlloCorrettezza();
        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.clicks > this.state.clicks) {
            this.onClickAggiungiContatti()
        }
        if (prevState !== this.state) {
            let objFinal = this.createJsonForBackend()
            this.props.setContatto(this.state.contatto, this, objFinal)
        }

        this.disabledSelectAutocomplete()
    }

    disabledSelectAutocomplete() {
        let condizione = this.props.segnalazioneDatiSpecificiCopia && this.props.segnalazioneDatiSpecificiCopia.migrazione || (this.props.segnalazioneDatiSpecificiCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
            this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)
        Utils.disabledSelectAutocomplete(condizione)
    }

    uniqueObjectContatti(elContatti) {
        const tmpcontatti = new Map()
        let stato = JSON.parse(JSON.stringify(this.state.contatto))

        const rscontatti = elContatti.reduce((acc, e) => {
            if (tmpcontatti.has(e.contatto) && tmpcontatti.has(e.grado)) {
                if (!tmpcontatti.get(e.contatto).includes(e.jobid) && !tmpcontatti.get(e.grado).includes(e.jobid)) {
                    acc.push(e)
                    tmpcontatti.set(e.contatto, [...tmpcontatti.get(e.contatto), e.jobid])
                    tmpcontatti.set(e.grado, [...tmpcontatti.get(e.grado), e.jobid])
                }
            } else {
                acc.push(e)
                tmpcontatti.set(e.contatto, [e.jobid])
                tmpcontatti.set(e.grado, [e.jobid])
            }
            return acc
        }, [])

        stato.listaContatti = rscontatti
        return stato
    }

    createJsonForBackend(stato) {

        let contatto = JSON.parse(JSON.stringify(stato ? stato : this.state.contatto));
        let contattoPulito = {}
        let listaContattiPulita = []
        let arrayContattoPulito = []

        for (let i = 0; i < contatto.listaContatti.length; i++) {
            arrayContattoPulito = []
            let contattoSingolo = Utils.removeEmptyValueFromObject(contatto.listaContatti[i])

            if (arrayContattoPulito.length > 0) {
                contattoSingolo["listaContatti"] = arrayContattoPulito
            } else {
                Utils.removeFieldFromObject(contattoSingolo, "listaContatti")
            }
            if (!Utils.isEmpty(contattoSingolo)) {
                listaContattiPulita.push(contattoSingolo)
            }
        }
        if (listaContattiPulita.length > 0) {
            contattoPulito["listaContatti"] = listaContattiPulita
        }
        let objFinal = Utils.removeEmptyValueFromObject(contattoPulito)
        return objFinal
    }


    controlloCorrettezza() {
        let contatti = this.state.contatto
        for (let i = 0; i < contatti.listaContatti.length; i++) {
            if (contatti.listaContatti[i].contatto === null || contatti.listaContatti[i].contatto === undefined || contatti.listaContatti[i].contatto === "") {
                contatti.corretto = ["Campo \"Contatto\" mancante"]
                break;
            } else {
                contatti.corretto = []
            }
        }

        this.setState({contatto: contatti})
    }

    validate() {

        //let contatti = this.state.contatto
        for (let i = 0; this.state.contatto.listaContatti[i]; i++) {
            if (this.state.contatto.listaContatti[i].contatto === "56" && !this.state.contatto.listaContatti[i].grado) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_AGCONTATTI"]), 1
                )
            }

        }

        let contatto = JSON.parse(JSON.stringify(this.state.contatto.listaContatti))
        let arrayContattoPulito = Utils.removeEmptyValueFromObject(contatto)
        let arrayNuovoContatto = Utils.eliminaNullArray(arrayContattoPulito)

        let objFinal = this.createJsonForBackend(this.uniqueObjectContatti(arrayNuovoContatto))
        this.props.setContatto(this.state.contatto, this, objFinal);
    }

    handleChangeContatto(event) {
        let clicks = this.state.clicks - 1;
        let contatto = this.state.contatto;
        let id = parseInt(event.target.id.replace("contatto", ""))
        contatto.listaContatti[id].contatto = event.target.value;
        if (contatto.listaContatti[id].contatto !== "56") {
            contatto.listaContatti[id].grado = ""
        }
        this.setState({contatto: contatto, clicks: clicks});
        this.controlloCorrettezza()
    }

    handleChangeGradoRelazioneContatto(event) {
        let clicks = this.state.clicks - 1;
        let contatto = this.state.contatto;
        let id = parseInt(event.target.id.replace("grado", ""))
        contatto.listaContatti[id].grado = event.target.value;
        this.setState({contatto: contatto, clicks: clicks});
        this.controlloCorrettezza()
    }

    eliminaRow(i){
        let strutturaContatto = this.state.contatto;
        let boxesContatti = this.state.boxesContatti
        let clicks = this.state.clicks
        strutturaContatto.listaContatti.splice(i,1)
        boxesContatti.splice(i,1)
        this.setState({boxesContatti: boxesContatti, contatto: strutturaContatto});
        if(i===1) clicks = clicks - 1
        else clicks = clicks - 2
        this.onClickAggiungiContatti(clicks)

    }

    onClickAggiungiContatti(clickElimina) {
        let clicks = clickElimina ? clickElimina : this.state.clicks === this.state.contatto.listaContatti.length ? this.state.clicks : this.state.clicks + 1
        let boxesContatti = []
        const {t} = this.props;
        let keys = Object.keys(this.state.listaGrado);
        for (let i = 0; i < clicks; i++) {
            boxesContatti.push(
                <div>
                    <div className="row">
                        <div className="col-lg-5">

                            <p className={styles.testo}>{t("DatiSpecifici.Contatti.contatto")}
                                <span className={styles.mandatoryColor}>*</span></p>
                            <div className={"row"}>
                                <div className={`col-lg-11 ${this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    <SelectAutocomplete
                                        style={{width: "100%"}}
                                        field={"contatto" + i}
                                        value={this.state.contatto.listaContatti[i].contatto === "159*"? "159" : this.state.contatto.listaContatti[i].contatto}
                                        onChange={this.handleChangeContatto}
                                        id={"contatto" + i}
                                        disabled={this.props.segnalazioneDatiSpecificiCopia.migrazione || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneDatiSpecificiCopia && (this.props.segnalazioneDatiSpecificiCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                            this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice))}
                                        functionMap={this.state.listaContattiSelect.map((oggetto) => {
                                            return (
                                                <option value={oggetto.codiceContatto}>{oggetto.descrizioneContatto}</option>)
                                        })}
                                        addclass={!this.props.segnalazioneDatiSpecificiCopia.stepConfermati.datiSpecificiConfermati && this.props.malattiePremal.includes(this.props.malattia) && this.state.contatto.listaContatti[i].contatto === "159*"? 'select-yellow' : !this.props.segnalazioneDatiSpecificiCopia.stepConfermati.datiSpecificiConfermati? 'select-white' : ''}
                                    >
                                    </SelectAutocomplete>
                                </div>

                            {
                                i>0 && !(this.props.segnalazioneDatiSpecificiCopia && this.props.segnalazioneDatiSpecificiCopia.migrazione || (this.props.segnalazioneDatiSpecificiCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                        this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice))
                                    ? <div className={"col-lg-1"}>
                                    <span id={i}
                                          onClick={()=>
                                              this.eliminaRow(i)

                                          }
                                    ><Icon id={"it-delete"} style={{fill: "red", marginTop: "5px", cursor: "pointer"}} /></span>
                                    </div>
                                    : <></>
                            }

                            </div>
                        </div>
                        {this.state.contatto.listaContatti[i] && this.state.contatto.listaContatti[i].contatto === "56" ?
                            <div className={`col-lg-4 ${this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                <p className={styles.testo}>{t("DatiSpecifici.Contatti.grado")}
                                    {this.state.contatto.listaContatti[i].contatto === "56" ?
                                        <span className={styles.mandatoryColor}>*</span> : ""
                                    }</p>
                                <Select
                                    field={"grado" + i}
                                    value={this.state.contatto.listaContatti[i].grado}
                                    onChange={this.handleChangeGradoRelazioneContatto}
                                    id={"grado" + i}
                                    style={{width: "100%"}}
                                    functionMap={keys.map((key) => {
                                        return (<option value={this.state.listaGrado[key]["codice"]}>
                                            {this.state.listaGrado[key]["descrizione"]}</option>)
                                    })}
                                >
                                </Select>
                            </div> : <div className="col-lg-4"/>}
                        <div className="col-lg-3" style={{marginTop: "-7px"}}>
                            {i < 1 ? <Button
                                    onClick={() => {
                                        this.aggiungiContatto();
                                        this.onClickAggiungiContatti()
                                    }}
                                    className={styles.testo}
                                    classes="btn mt-2 btnBluOutline mb-1 "
                                    style={{
                                        marginTop: "3rem", border: "none", background: "none", float: "right",
                                        opacity: this.props.segnalazioneDatiSpecificiCopia && this.props.segnalazioneDatiSpecificiCopia.migrazione || (this.props.segnalazioneDatiSpecificiCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                            this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) ? "0.5" : ""
                                    }}
                                    text={t("DatiSpecifici.Contatti.aggiungi")}
                                    icon={<Icon style={{paddingLeft: "4px", fill: "#0073e6"}} id="it-plus-circle"/>}
                                    disabled={this.props.segnalazioneDatiSpecificiCopia && this.props.segnalazioneDatiSpecificiCopia.migrazione || (this.props.segnalazioneDatiSpecificiCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                        this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}
                                />
                                :
                                <div/>}

                        </div>
                    </div>
                </div>
            )

        }
        this.setState({clicks: clicks, boxesContatti: boxesContatti});
        this.controlloCorrettezza()

    }

    aggiungiContatto() {
        let strutturaContatto = this.state.contatto;
        strutturaContatto.listaContatti.push({
            contatto: "",
            grado: ""
        });
        this.setState({contatto: strutturaContatto});
        this.controlloCorrettezza()
    }


    render() {
        const {t} = this.props;
        const firstSection = (
            <div style={{marginTop: "1rem"}}>
                <h6>{t("DatiSpecifici.Contatti.titolo")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>
                    {this.state.boxesContatti}
                </div>
            </div>
        );


        return (
            <div style={{marginTop: "1rem"}}>
                {firstSection}

            </div>

        );
    }
}

export default withTranslation('common')(Contatti);
